import { render, staticRenderFns } from "./AddAnchorGroupDialog.vue?vue&type=template&id=b311320a&scoped=true"
import script from "./AddAnchorGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddAnchorGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAnchorGroupDialog.vue?vue&type=style&index=0&id=b311320a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b311320a",
  null
  
)

export default component.exports